export default __webpack_public_path__ + "static/media/backgroundMusic.4df4188d.mp3";